/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect} from "react";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import { Link} from "react-router-dom";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import toast, {Toaster} from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket, faTrash, faUserLock } from "@fortawesome/free-solid-svg-icons";
import DeleteAccount from "../../DeleteAccount";
import jsPDF from "jspdf";
import "jspdf-autotable";
import SearchForm from "../../../Components/Common/SearchForm";
import Pagination from "../../../Components/Common/Pagination";
import ContactContext from "../../../Context/ContactContext";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import RemoteLogoutParent from "./RemoteLogoutParent";

function ViewParentsPage() {

  const [modal, setModal] = useStateCallback(false);
  const {contactList, getContactList, searchContacts, sortContactList, loading, loading2, loading4, meta, first, query, page, setQuery, setPage, isSorted, setIsSorted } = useContext(ContactContext);

  useEffect(() => {
    if (query) {
      searchContacts();
    } else if (isSorted) {
      sortContactList(page);
    }else {
      getContactList(page);
    }
  }, [page, isSorted]);

  const refreshData = () =>{
    getContactList(1)
  }

  const sortData = () =>{
    setQuery("");
    setPage(1);
    setIsSorted(true);
    sortContactList(1)
  }

  const setParents = (e) => {
    e.preventDefault();
    setQuery("");
    setPage(1);
    setIsSorted(false);
    getContactList(1);
  };

  const remoteLogout = (e, item) => {
    setModal(false, () =>
      setModal(
        <RemoteLogoutParent
          userID={item.user_id}
          isOpen={true}
        />
      )
    );
  };

  const getDefaultPin = async (e,item) => {
    e.preventDefault()
    const server_response = await ajaxStudent.setDefaultPin(item.user_id);
    if (server_response.status === "OK") {
      toast.success(server_response.message, {duration: 10000});
      getContactList(page);
    }
  };

  const handleDelete = (e, item) => {
    setModal(false, () =>
      setModal(
        <DeleteAccount
          userID={item.user_id}
          g={getContactList}
          isOpen={true}
          page={page}
        />
      )
    );
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Names", "Contact Number"];
    const data = contactList.map(item => [
      item.full_name,
      item.username
    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("parent_list.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  

  return(
    <AppContainer title="Contacts">

      <Toaster position="top-center" reverseOrder={false} />
      {modal}
      <div className="row"> 
        <div className="col-lg-12">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                <TableHeader
                  title="Contacts List"
                  subtitle="List of all the contacts sorted in ascending order"
                />
                <div class="dropdown">
                  <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
                  <div class="dropdown-menu dropdown-menu-right">
                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                    <Link class="dropdown-item" onClick={sortData} ><i class="fas fa-arrow-down-wide-short text-dodger-blue"></i>Sort (Recent Signup)</Link>
                    
                    <Link class="dropdown-item" onClick={exportToPDF} ><i class="fas fa-file-export"></i>Export</Link>
                    <Link class="dropdown-item" to={'/deleted-users'} ><i class="fa-solid fa-eye text-orange-peel"></i>View Deleted Accounts</Link>
                  </div>
                </div>
              </div>

              <SearchForm searchTerm={query} setSearchTerm={setQuery} searchItems={searchContacts} setItems={setParents} setPage={setPage} placeholder="Enter first or last name of user..."/>

              <div className="border-top mt-3"></div>
              <div className="table-responsive">
                {loading || loading2 || loading4 ? (
                  <Loader />
                ) : (
                  <table className="table display data-table text-nowrap">
                    <thead>
                      <tr>
                      <th scope="col" className="wd-10p">No.</th>
                              <th scope="col">Names</th>
                              <th scope="col">Contact Number</th>
                              <th scope="col">Gender</th>
                              <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contactList.length > 0 ? (
                        contactList.map((item, index) => (
                          <tr key={index}>
                            <th scope='row' style={{width:"5px"}}>{index + first + 1}</th>
                                <td><Link
                                to={`/parents/profile/${item.parent_id}/${item.user_id}`}>
                                {item.full_name}
                              </Link></td>
                                <td>{item.username}</td>
                                <td>{item.gender}</td>
                                <td>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false">
                        <span className="flaticon-more-button-of-three-dots"></span>
                      </Link>
                      <div className="dropdown-menu dropdown-menu-right">
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={(e) => getDefaultPin(e,item)}>
                        <FontAwesomeIcon icon={faUserLock} style={{ color: "teal", marginRight: "3px" }} />
                        Set Default PIN
                    </Link>
                      
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={(e) => remoteLogout(e,item)}>
                        <FontAwesomeIcon icon={faArrowRightFromBracket} style={{ color: "red", marginRight: "3px" }} />
                        Remote Log-Out
                      </Link>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={(e) => handleDelete(e,item)}>
                        <FontAwesomeIcon icon={faTrash} style={{ color: "red", marginRight: "3px" }} />
                        Delete Account
                      </Link>
        </div>
                    </div>
                  </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" style={{ textAlign: "center" }}>
                            No parents registered yet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
            </div>
          </div>
        </div>
      </div> 
      
    </AppContainer>
  )
}

export default ViewParentsPage;